import { IMobCellResponse, MOB_STATUS } from "@/store/apis/mobsAPI/mobs.types"

export type IKindAvailability = "free" | "taken" | "gone" | "unknown"

export const kindAvailability = (
  entry: IMobCellResponse | undefined,
  typeCode: string,
  level: number
): IKindAvailability => {
  if (entry === undefined) {
    return "unknown"
  }
  const kind = entry.mobs.filter(
    (row) => row.typeCode === typeCode && row.level === level
  )
  if (kind.length === 0) {
    return "gone"
  }
  return kind.some((row) => row.status === MOB_STATUS.ALIVE) ? "free" : "taken"
}

export const isMobStillFighting = (
  entry: IMobCellResponse | undefined,
  mobId: string
): boolean =>
  entry === undefined ||
  entry.mobs.find((row) => row.id === mobId)?.status === MOB_STATUS.IN_COMBAT
